module.exports = __webpack_public_path__ + "3a128a7ded47114ec0afe223bda7d421.png";